// @flow

import React from 'react';

import {gt} from 'app/utils/i18n';
import {StoredProceduresFetcher} from 'app/procedures/datafetchers';
import {SORT_BY_TYPES} from 'app/utils/constants';
import {CompactProcedureListItem} from 'app/procedures/components/CompactProcedureListItem';
import {GenericPaginatedList} from 'app/components/general/lists/GenericPaginatedList';

export const ProcedureList = () => (
  <GenericPaginatedList
    ItemComponent={AdaptedProcedureListItem}
    FetcherComponent={StoredProceduresFetcher}
    noItemsMessage={() =>
      gt("This member doesn't have access to any procedures")
    }
    paramsBuilder={({params}) => ({visible_to_user: params.userid})}
    customProps={() => ({
      Actions: null,
      sortBy: SORT_BY_TYPES.MODIFICATION_DATE,
    })}
  />
);

const AdaptedProcedureListItem = ({refetchList, ...props}) => (
  <CompactProcedureListItem refreshData={refetchList} {...props} />
);
